import { api } from '../api'

const CheckToken = async (token) => {
  const response = await api.post('/validar/token/login', { token })
  // @ts-ignore
  return response.data.itens[0].status
}

export default CheckToken
